<template>
  <div>
    <vx-card class="mb-5">
      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-input
            placeholder="Title"
            vs-placeholder="Title"
            v-model="notification.title"
            class="mt-3 w-full"
            dir="rtl"
          />
        </vs-col>

        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-textarea
            placeholder="Body"
            vs-placeholder="Body"
            v-model="notification.body"
            class="mt-3 w-full"
            dir="rtl"
          />
        </vs-col>

        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-input
            placeholder="Link"
            vs-placeholder="Link"
            v-model="notification.link"
            class="mt-3 w-full"
          />
        </vs-col>

        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button
            class="mt-3 w-full"
            color="success"
            type="border"
            @click="sendNotification"
            >Send Notification</vs-button
          >
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
// import addEditForm from "./form";
import { BTable } from "bootstrap-vue";
import { BRow, BCol } from "bootstrap-vue";

export default {
  components: {
    BTable,
    BRow,
    BCol
  },
  data: () => ({
    deleteItemId: -1,
    deletePrompt: false,
    activePrompt: false,
    data: null,
    notification: {
      title: null,
      body: null,
      link: null
    }
  }),
  mounted() {},

  methods: {
    async sendNotification() {
      await this.$vs.loading();
      await axios
        .post("/dashboard/send-notification/", this.notification)
        .then(response => {
          this.data = response.data.data;
          this.result = true;
        });
      await this.$vs.loading.close();
    }
  }
};
</script>
